export default "__VITE_ASSET__1bdf3b91__"